'use client';

import { SettingsEmptyState } from '@terra/ui-design-system';
import { useTranslations } from 'next-intl';

type TargetNoTargetStateProps = {
  descriptionKey: 'domains' | 'credentials' | 'roles';
};

export function TargetNoTargetState({
  descriptionKey,
}: TargetNoTargetStateProps) {
  const t = useTranslations('settings.targetSettings.noTarget');

  return <SettingsEmptyState>{t(descriptionKey)}</SettingsEmptyState>;
}
